
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'

import ScrollToTop from './ScrollToTop.js'

import NoMatch from './routes/NoMatch'

import Tool from './routes/Tool'

import Login from './routes/Login'
import LogOut from './routes/LogOut'
import Forgot from './routes/Forgot'
import AtWork from './routes/AtWork'
import CreateATeam from './routes/Create-A-Team'
import CreateAnEnterprise from './routes/Create-An-Enterprise'
import ResetPassword from './routes/ResetPassword'
import Register from './routes/Register'
import AcceptInvite from './routes/AcceptInvite'

import LandingPage from './routes/LandingPage'
import PricingRoute from './routes/PricingRoute'
import Features from './routes/Features'
import SearchResults from './routes/SearchResults'
import FeatureTable from './routes/FeatureTable'
import Compare from './routes/Compare'
import WhatIsPattycake from './routes/WhatIsPattycake'
import Docs from './routes/Docs'
import Docs_WP from './routes/Docs_WP'


// import TeamDashboard from './routes/TeamDashboard'
// import MyDashboard from './routes/MyDashboard'
import Settings from './routes/Settings'

import Contact from './routes/Contact'
import BecomeAPartner from './routes/BecomeAPartner'
import TermsOfService from './routes/TermsOfService'
import PrivacyPolicy from './routes/PrivacyPolicy'
import ConfirmMyEmail from './routes/ConfirmMyEmail'

import Tooltip from './components/Tooltip/Tooltip.js'
import Toast from './components/Toast/Toast.js'

import TestRoute from './routes/_TestRoute.js'
import StyleGuideRoute from './routes/StyleGuide.js'

import { 
  loadToken,
  addToast, 
  tryToFetchMyAccountInfo, 
  tryToFetchMyTeams, 
  tryToFetchMyPendingInvites,
  addVerifyEmailToast,
  addDelinquentTeamToast,
  addDelinquentUserToast,
  tryToGetOfficialPatterns
} from './actions/actions.export.js';

var Cookies = require('js-cookie');

class App extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount(){

    console.log(process.env);

    const { dispatch, user } = this.props;
    
    Cookies.remove(process.env.REACT_APP_COOKIE_MFA_AUTH);

    var consentCookie = Cookies.get('cookieToastDismissed');
    if(!consentCookie && !user.isLoggedIn){
      dispatch(addToast({
        title: "We use cookies 🍪",
        detail: "In order to keep you logged in, keep track of your settings, and measure use of Pattycake, we store a few cookies in your browser.",
        func: 'cookieToastDismissed',
        buttons: [
          {
            display: "Accept",
            dismissOnClick: true,
            destination: '/privacy'
          },
          {
            display: "More Info",
            destination: '/privacy'
          }
        ]
      }));
    }

    dispatch(tryToGetOfficialPatterns());
    if(user.isLoggedIn){
      // dispatch(loadToken());
      dispatch(tryToFetchMyAccountInfo());
      dispatch(tryToFetchMyTeams());

      if(!user.email_verified){
        dispatch(addVerifyEmailToast())
      } else {
        dispatch(tryToFetchMyPendingInvites());
      }
    }
  } 

  componentWillReceiveProps(newprops){
    const { dispatch, toast } = this.props;

    if(newprops.user.delinquent){
      let toast_found = toast.toast_list.find(el => el.id === 'delinquent_user');
      if(!toast_found) dispatch(addDelinquentUserToast());
    }

    for(var i in newprops.team.cache){
      let t = newprops.team.cache[i];
      if(t.delinquent){
        let toast_found = toast.toast_list.find(el => el.id === 'delinquent_team_' + t.id);
        if(!toast_found && !newprops.toast['dismissed_' + 'delinquent_team_' + t.id]){
          dispatch(addDelinquentTeamToast({
            team: {
              id: t.id,
              me: newprops.user.id,
              display_name: t.display_name
            }
          }))
        }
      }
    }
  }

  render(){
    const { history, user } = this.props;
  
    return <ConnectedRouter history={history}>
      <ScrollToTop>

      <div>
        <Tooltip/>
        <Toast/>
        
        <div className="body-wrapper">
            <Switch>

              <Route exact path="/" component={LandingPage}/>
              <Route exact path="/feature-table" component={FeatureTable}/>
              {/*<Route path="/compare/:compare" component={Compare}/>*/}
              {/*<Route exact path="/compare" exact={true} component={Compare}/>*/}
              <Route exact path="/at-work" component={AtWork}/>
              <Route exact path="/🎂" component={NoMatch}/>
              <Route exact path="/contact" component={Contact}/>
              <Route path="/become-a-partner" component={BecomeAPartner}/>
              <Route path="/privacy" component={PrivacyPolicy}/>
              <Route path="/pricing" component={PricingRoute}/>
              <Route exact path="/search" component={SearchResults}/>
              <Route exact path="/search/:term" component={SearchResults}/>
              {/*<Route path="/features" component={Features}/>*/}
              <Route exact path="/docs" component={Docs}/>
              <Route exact path="/docs/d/:slug" component={Docs}/>
              <Route exact path="/docs/category/:categorySlug" component={Docs}/>
              <Route exact path="/docs/tag/:tagSlug" component={Docs}/>
              {/*<Route exact path="/docs" component={Docs_WP}/>
              <Route exact path="/doc/:slug" component={Docs_WP}/>
              <Route exact path="/docs/in/category/:categorySlug" component={Docs_WP} />
              <Route exact path="/docs/with/tag/:tagSlug" component={Docs_WP} />*/}
              <Route exact path="/tos" component={TermsOfService}/>
              <Route exact path="/🙏" component={WhatIsPattycake}/>

              {/*<Route path="/test" component={TestRoute}/>*/}
              <Route path="/style-guide" component={StyleGuideRoute}/>

              <Route exact path="/confirm-my-email/:code" component={ConfirmMyEmail}/>
              <Route exact path="/recover/:code" component={ResetPassword}/>
             
              <Route exact path="/login" component={Login}/>
              <Route path="/logout" component={LogOut}/>
              <Route path="/sign-up" component={Register}/>
              <Route exact path="/pattycake-for-firms-sign-up" component={CreateATeam}/>
              {/*<Route exact path="/pattycake-enterprise-sign-up" component={CreateAnEnterprise}/>*/}
              <Route path="/forgot" component={Forgot}/>
              <Route path="/accept-invitation/:invite_code" component={AcceptInvite}/>
              
              <Route exact path="/new" component={Tool} />
              <Route exact path="/new/drawing" component={Tool} />
              <Route exact path="/new/template" component={Tool} />
              <Route exact path="/new/dxf" component={Tool} />
              <Route exact path="/new/import" component={Tool} />
              <Route exact path="/new/imported" component={Tool} />


              <Route exact path="/pat" component={Tool} />
              <Route exact path="/pat/:pattern_hash_id" component={Tool} />

              <Route exact path="/pat/:pattern_hash_id" component={Tool} />
              <Route exact path="/:namespace/pat/:pattern_hash_id" render={(props) => (
                <Redirect to={'/pat/' + props.match.params.pattern_hash_id} {...props} />)
              } />
              

              <Route exact path="/settings">
                {user.isLoggedIn ? <Redirect to="/settings/my-account" /> : <Redirect to="/🎂" />}
              </Route>

              <Route exact path="/settings/my-account" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />
              <Route exact path="/settings/my-account/:page" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />
              <Route exact path="/settings/my-account/:page/:subpage" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />

              <Route exact path="/settings/firm/:team_hash_id" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />

              <Route exact path="/settings/team/:team_hash_id" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />
{/*
              <Route exact path="/settings/enterprise/:team_hash_id" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />*/}

              <Route exact path="/settings/firm/:team_hash_id/:page" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />

              <Route exact path="/settings/team/:team_hash_id/:page" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />
{/*
              <Route exact path="/settings/enterprise/:team_hash_id/:page" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />*/}

              <Route exact path="/settings/team/:team_hash_id/:page/:subpage" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />

              <Route exact path="/settings/firm/:team_hash_id/:page/:subpage" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />
              {/*
              <Route exact path="/settings/enterprise/:team_hash_id/:page/:subpage" render={(props) => (
                <Settings key={'my_' + props.match.params.page} {...props} />)
              } />*/}
            {/*
              <Route exact path="/my/settings" component={MyDashboard}/>
              <Route exact path="/my/settings/:page" render={(props) => (
                <MyDashboard key={'my_' + props.match.params.page} {...props} />)
              } />
              
              <Route exact path="/team/:team_hash_id/settings" render={(props) => (
                <TeamDashboard key={props.match.params.team_hash_id + '_' + props.match.params.page} {...props} />)
              } />
              <Route exact path="/team/:team_hash_id/settings/:page" render={(props) => (
                <TeamDashboard key={props.match.params.team_hash_id + '_' + props.match.params.page} {...props} />)
              } />
              */}
              
              <Redirect to='/🎂' />
            </Switch>
          </div>
        </div>
      </ScrollToTop>
    </ConnectedRouter>
  }
}

const mapStateToProps = (state) => {
  const { 
    toast,
    user,
    team
    //...
  } = state;

  return {
    toast,
    user,
    team
    //...
  }
}

export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js